// TODO_R: rename to .ts file
// TODO_R: [RCC] have a look into Bitcoin analog
import BigNumber from 'bignumber.js';
import { isEmpty } from 'lodash';
import { IClaimMultiSignWallet, IMultiSignWallet } from 'types';

export function formatBalanceString(num: string | number): string {
  return Number(num)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function shortenText(text: string | number = '', length = 12) {
  if (typeof text === 'number') text = new BigNumber(text.toString()).toFixed();
  if (text.length <= length) return text;

  return `${text.slice(0, length)}...`;
}

export function shortenAddress(address = '', slice = 5, endSlice = 4) {
  if (address.length < 11) {
    return address;
  }

  return `${address.slice(0, slice)}...${address.slice(-endSlice)}`;
}

export const getAccountExplorerUrl = (address: string, network?: string) => {
  return `https://explorer.hiro.so/address/${address}?chain=${network || 'mainnet'}`;
};

export const getTxnExplorerUrl = (address: string, network: string) => {
  return `https://explorer.hiro.so/txid/${address}?chain=${network}`;
};

export function stringToColor(stringColor: string) {
  if (isEmpty(stringColor)) {
    return '#000000';
  }
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < stringColor.length; i += 1) {
    hash = stringColor.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export const formatSafeDate = (dateString: Date) => {
  const date = new Date(dateString);

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
};

export const isPendingSafe = (
  safe: IClaimMultiSignWallet | IMultiSignWallet
): safe is IClaimMultiSignWallet => !('address' in safe);

export const displayUsdValue = (
  floorPrice: number | string,
  amount: number | string,
  btcPrice?: number | string
) => {
  const total = (Number(btcPrice || 0) / Math.pow(10, 8)) * Number(floorPrice) * Number(amount);
  if (!total) return '-';

  return `~$${total.toFixed(6)}`;
};

export function displayWithFormat(val: string | undefined) {
  const amount = val ? Number(val) : 0;

  return amount.toString();
}

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
};
export const isEqualPermissions = (a: Record<string, string[]>, b: Record<string, string[]>) => {
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) return false;

  return aKeys.every((key) => {
    if (!b[key]) return false;

    const arrA = [...a[key]].sort();
    const arrB = [...b[key]].sort();

    return arrA.length === arrB.length && arrA.every((val, i) => val === arrB[i]);
  });
};
